var request = require('./request.js')

// 生鲜柜相关API
var EloginApi = {
	// 快递员登录
	userLogin: function (data) {
		return request.adminPost('/service/App/User/CourierLogin.json', data)
	},
	//获取设备剩余箱柜信息
	BoxAmountInfo: function(data,token){
		return request.post('/service/App/Device/GetBoxNum.json',data,token)
	},
	//投递
	sendExpress: function(data,token){
		return request.post('/service/App/ExpressBusiness/SendExpress.json',data,token)
	},
	//取件出库
	openBox: function(data){
		return request.adminPost('/service/App/ExpressBusiness/UserOpenBox.json',data)
	},


	// 获取公司信息
	getCompInfo: function (data) {
		return request.get('/RestAPI/Cabinet/getAllInfomationById/id/'+data)
	},
	//获取主页面显示的菜单信息
	getMenuList: function(data) {
		return request.get('/RestAPI/User/getCompanyRules/company/'+data)
	},
	//发送短信验证码
	sendSmsCode: function(data) {
		return request.postform('/RestAPI/Valid/sendvalid',data)
	},
	//发送短信语音验证码
	sendSmsVoiceCode: function(data) {
		return request.postform2('/RestAPI/Valid/SendVoiceVerify',data)
	},
	//找回密码
	getBackPassword: function(data){
		return request.post('/RestAPI/Common/userModifyPassword', data)
	},
	//获取注册二维码
	getRegisterEwm: function(data){
		return request.postform2('/RestAPI/Cabinet/getAllInfomationById', data)
	},
	//获取入库未确认的订单
	getUnconfirmedOrders: function(data){
		return request.post('/RestAPI/StorageBusiness/getUnconfirmedOrders', data)
	},
	//获取已入库的订单
	getStoragedOrders: function(data){
		return request.post('/RestAPI/StorageBusiness/getStoragedOrders', data)
	},
	//确认入库
	confirmOrders: function(data){
		return request.post('/RestAPI/ExpressBusiness/confirmOrders', data)
	},
	//取消入库
	cancelUnConfirmOrders: function(data){
		return request.post('/RestAPI/ExpressBusiness/cancelUnConfirmOrders', data)
	},
	
	
	//扫码
	scanCode: function(data){
		return request.post('/RestAPI/BasicBox/scanCode',data)
	},
	//取消扫码
	cancelScanCode: function(data){
		return request.post('/RestAPI/BasicBox/cancelScanCode',data)
	},
	
}

var StoreApi = {
	//打开仓库外门(在通道内有人时才开)
	panelOuterDoor: function(data){
		return request.post('/RestAPI/StorageBusiness/panelOuterDoor',data)
	},
	//打开仓库外门，不检测通道内是否有人
	shipmentOpen: function(data){
		return request.post('/RestAPI/StorageBusiness/shipmentOpen',data)
	},
	//打开仓库内门，不检测是否有人
	storageInternalOpen: function(data){
		return request.post('/RestAPI/StorageBusiness/storageInternalOpen',data)
	},
	//重新扫描rfid
	afreshRfid: function(){
		return request.post('/RestAPI/BasicBox/afreshRfid')
	},
}

export {
	EloginApi,
	StoreApi
}



//////////////////
// WEBPACK FOOTER
// ./static/FreshCabinet/js/api.js
// module id = null
// module chunks = 